<template>
  <div class="columns" data-track="Portal-Home">
    <template v-if="isMobile">
      <div class="header--mobile">
        <p class="mobile-greeter has-text-centered" v-html="greeterMobile"></p>
        <p class="mobile-greeter-experience has-text-centered">For full experience login on
          desktop.</p>
        <the-update-alert class="margin-top-20"/>
      </div>
    </template>
    <div class="column is-four-fifths-desktop new-home">
      <template v-if="!isMobile">
        <p class="greeter">Welcome back,</p>
        <p class="name-only" v-html="greeter"></p>
      </template>
      <div v-if="isAvailableForBlackFriday" class="columns">
        <div class="column is-one-half">
          <img alt="Claim your 1000 Free Extra Review Invites" class="black-friday-banner-img"
               src="/static/img/new/black-friday/bf-banner-left.png"
               srcset="/static/img/new/black-friday/bf-banner-left@2x.png 1.5x,/static/img/new/black-friday/bf-banner-left@2x.png 2x, /static/img/new/black-friday/bf-banner-left@3x.png 3x"/>
        </div>
        <div class="column is-one-half">
          <a data-track="Upgrade Black Friday CTA portal home" href="/billing/edit-plan/g1/monthly"><img
            alt="Save up to 60%" class="black-friday-banner-img" src="/static/img/new/black-friday/bf-banner-right.png"
            srcset="/static/img/new/black-friday/bf-banner-right@2x.png 1.5x,/static/img/new/black-friday/bf-banner-right@2x.png 2x, /static/img/new/black-friday/bf-banner-right@3x.png 3x"/></a>
        </div>
      </div>
      <div v-if="!isGettingInfo" class="columns">
        <div class="column is-one-third">
          <div class="fixed-card">
            <h4>I want to</h4>
            <h3>COLLECT&nbsp;REVIEWS</h3>
            <div class="columns collect-reviews is-mobile">
              <div class="column is-one-third has-text-centered">
                <img
                  src="/static/img/new/home/whatsapp.png"
                  srcset="
                    /static/img/new/home/whatsapp@2x.png 1.5x,
                    /static/img/new/home/whatsapp@2x.png 2x,
                    /static/img/new/home/whatsapp@3x.png 3x
                  "
                />
                <h2>WhatsApp&nbsp;Link</h2>
              </div>
              <div class="column is-one-third has-text-centered">
                <img
                  class="collect-img"
                  src="/static/img/new/home/email.png"
                  srcset="
                    /static/img/new/home/email@2x.png 1.5x,
                    /static/img/new/home/email@2x.png 2x,
                    /static/img/new/home/email@3x.png 3x
                  "
                />
                <h2>Email&nbsp;&amp;&nbsp;SMS</h2>
              </div>
              <div class="column is-one-third has-text-centered">
                <img
                  class="collect-img"
                  src="/static/img/new/home/qr.png"
                  srcset="
                    /static/img/new/home/qr@2x.png 1.5x,
                    /static/img/new/home/qr@2x.png 2x,
                    /static/img/new/home/qr@3x.png 3x
                  "
                />
                <h2>QR&nbsp;Code</h2>
              </div>
            </div>
            <button class="home-btn has-text-centered" data-track="Clicked Collect Now Button from Portal Home Page"
                    @click.prevent="launchCollectModal()">Collect Now
            </button>
          </div>
        </div>
        <div class="column is-one-third">
          <div class="fixed-card">
            <h4>I want to</h4>
            <h3>REPLY&nbsp;TO&nbsp;REVIEWS</h3>
            <img :src="replyImage" :srcset="replyImageSet" class="single"/>
            <h5 class="has-text-centered" v-text="replyBold"></h5>
            <h6 class="has-text-centered" v-text="replyText"></h6>
            <button class="home-btn has-text-centered" data-track="clicked reply now button from new portal home page"
                    @click="$router.push('/reviews')" v-text="replyButtonText"></button>
          </div>
        </div>
        <div class="column is-one-third is-hidden-mobile">
          <div class="fixed-card sync">
            <h4>I want to</h4>
            <h3>SYNC&nbsp;MY&nbsp;REVIEWS</h3>
            <p class="sync-text">
              Effortlessly manage all your Hellopeter, Facebook and Google
              reviews by syncing it to one inbox
            </p>
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">
                  <img
                    class="sync-hp"
                    src="/static/img/new/home/sync-hp.png"
                    srcset="
                      /static/img/new/home/sync-hp@2x.png 1.5x,
                      /static/img/new/home/sync-hp@2x.png 2x,
                      /static/img/new/home/sync-hp@3x.png 3x
                    "
                  />
                </div>
                <p class="level-item sync-label">Hellopeter</p>
              </div>
              <div class="level-right">
                <p class="level-item sync-connected">Connected</p>
              </div>
            </div>
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">
                  <img
                    class="sync-google"
                    src="/static/img/new/home/sync-google.png"
                    srcset="
                      /static/img/new/home/sync-google@2x.png 1.5x,
                      /static/img/new/home/sync-google@2x.png 2x,
                      /static/img/new/home/sync-google@3x.png 3x
                    "
                  />
                </div>
                <p class="level-item sync-label">Google</p>
              </div>
              <div v-if="isGMBSettedUp" class="level-right">
                <p class="level-item sync-connected">Connected</p>
              </div>
              <div v-if="!isGMBSettedUp && isFreeSubscription" class="level-right">
                <p class="level-item sync-locked"><img src="/static/img/new/home/locked.png"
                                                       srcset="/static/img/new/home/locked@2x.png 1.5x, /static/img/new/home/locked@2x.png 2x, /static/img/new/home/locked@3x.png 3x"/><a
                  data-track="upgrade plan Google Sync" href="/billing">Upgrade</a></p>
              </div>
              <div v-if="!isGMBSettedUp && !isFreeSubscription" class="level-right">
                <button class="sync-connect-btn has-text-centered" data-track="connect google portal home"
                        @click="toggleGMBModal = true">
                  Connect&nbsp;Google
                </button>
              </div>
            </div>
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">
                  <img
                    class="sync-fb"
                    src="/static/img/new/home/sync-fb.png"
                    srcset="
                      /static/img/new/home/sync-fb@2x.png 1.5x,
                      /static/img/new/home/sync-fb@2x.png 2x,
                      /static/img/new/home/sync-fb@3x.png 3x
                    "
                  />
                </div>
                <p class="level-item sync-label">Facebook</p>
              </div>
              <div v-if="isFacebookReviewsConnected" class="level-right">
                <p class="level-item sync-connected">Connected</p>
              </div>
              <div v-if="!isFacebookReviewsConnected && isFreeSubscription" class="level-right">
                <p class="level-item sync-locked"><img src="/static/img/new/home/locked.png"
                                                       srcset="/static/img/new/home/locked@2x.png 1.5x, /static/img/new/home/locked@2x.png 2x, /static/img/new/home/locked@3x.png 3x"/><a
                  data-track="upgrade plan Facebook sync" href="/billing">Upgrade</a></p>
              </div>
              <div v-if="!isFacebookReviewsConnected && !isFreeSubscription" class="level-right">
                <button class="sync-connect-btn has-text-centered" data-track="connect facebook portal home"
                        @click="openFB">
                  Connect&nbsp;Facebook
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="info.totalReviews > 9" class="performance level">
        <div class="level-left">
          <p class="level-item">Performance&nbsp;over&nbsp;time&nbsp;(excluding Google and Facebook):</p>
        </div>
        <div class="level-right">
          <p class="level-item is-hidden-mobile">Filter&nbsp;by:</p>
          <div class="level-item">
            <date-select-filter
              :filter_items="filters.dateFilter.props"
              :reviews_start_date="filters.dateFilter.reviews_start_date"
              :roundedBorder="!useColumnClass"
              :show-calendar-icon="useColumnClass"
              :styleProp="filters.dateFilter.styleProp"
              :use-column-class="useColumnClass"
              class="custom-dropdown"
              data-track="Portal Home Date Change Filter"
              @onDateChange="handleDateChange"
            />
          </div>
        </div>
      </div>
      <!-- PERFORMANCE LOADING -->
      <div v-if="fetching_performance && info.totalReviews > 9" class="columns">
        <div class="column"><p class="has-text-centered"><img alt="fetching performance metrics for selected period"
                                                              src="/static/img/ajax-loader.gif"/></p></div>
      </div>
      <!-- PERFORMANCE CARDS -->
      <div v-if="!fetching_performance && info.totalReviews > 9" class="columns">
        <!-- RATING -->
        <div class="column is-one-fifth">
          <div class="performance-card">
            <div class="performance-body">
              <p v-if="hasReviewsForPeriod" class="has-text-centered is-hidden-mobile">
                <rating :stars="stars"></rating>
              </p>
              <p class="has-text-centered is-uppercase is-hidden-mobile" v-html="starRatingValue"></p>
              <p class="has-text-centered is-uppercase is-hidden-desktop" v-html="starRatingValueMobile"></p>
            </div>
            <footer class="is-hidden-mobile">
              <div v-if="!isAllTimeSelected" class="level is-mobile">
                <div class="level-left">
                  <p class="level-item has-text-right" v-html="starRatingFooter"></p>
                  <p :class="['level-item', starRatingUpDown, 'has-text-left']" v-html="starRatingPercentage"></p>
                </div>
              </div>
            </footer>
          </div>
        </div>
        <!-- TRUSTINDEX -->
        <div class="column is-one-fifth">
          <div class="performance-card">
            <div class="performance-body">
              <p class="has-text-centered is-uppercase is-hidden-mobile" v-html="trustIndexValue"></p>
              <p class="has-text-centered is-uppercase is-hidden-desktop" v-html="trustIndexValueMobile"></p>
            </div>
            <footer class="is-hidden-mobile">
              <div v-if="!isAllTimeSelected" class="level is-mobile">
                <div class="level-left">
                  <p class="level-item has-text-right" v-html="trustIndexFooter"></p>
                  <p :class="['level-item', trustIndexUpDown, 'has-text-left']" v-html="trustIndexPercentage"></p>
                </div>
              </div>
            </footer>
          </div>
        </div>
        <!-- INDUSTRY -->
        <div class="column is-one-fifth">
          <div class="performance-card">
            <div class="performance-body">
              <p class="has-text-centered is-uppercase is-hidden-mobile" v-html="industryRankValue"></p>
              <p class="has-text-centered is-uppercase is-hidden-desktop" v-html="industryRankValueMobile"></p>
            </div>
            <footer class="is-hidden-mobile">
              <div v-if="!isAllTimeSelected" class="level is-mobile">
                <div class="level-left">
                  <p class="level-item has-text-right" v-html="industryFooter"></p>
                  <p :class="['level-item', industryUpDown, 'has-text-left']" v-html="industryPercentage"></p>
                </div>
              </div>
            </footer>
          </div>
        </div>
        <!-- TIME_TO_REPLY -->
        <div class="column is-one-fifth">
          <div class="performance-card">
            <div class="performance-body">
              <p class="has-text-centered is-uppercase is-hidden-mobile" v-html="timeToReplyValue"></p>
              <p class="has-text-centered is-uppercase is-hidden-desktop" v-html="timeToReplyValueMobile"></p>
            </div>
            <footer class="is-hidden-mobile">
              <div v-if="!isAllTimeSelected" class="level is-mobile">
                <div class="level-left">
                  <p class="level-item has-text-right" v-html="timeToReplyFooter"></p>
                  <p :class="['level-item', timeToReplyUpDown, 'has-text-left']" v-html="timeToReplyPercentage"></p>
                </div>
              </div>
            </footer>
          </div>
        </div>
        <!-- NPS -->
        <div class="column is-one-fifth">
          <div class="performance-card">
            <div class="performance-body">
              <p class="has-text-centered is-uppercase is-hidden-mobile">
                <b v-html="npsScoreValue"></b>nps<br/>recommend:
              </p>
              <p class="has-text-centered is-uppercase blue-nps is-hidden-mobile" v-html="npsImageValue"></p>
              <p class="has-text-centered is-uppercase is-hidden-desktop" v-html="npsScoreValueMobile"></p>
            </div>
            <footer class="is-hidden-mobile">
              <div v-if="!isAllTimeSelected" class="level is-mobile">
                <div class="level-left">
                  <p class="level-item has-text-right" v-html="npsFooter"></p>
                  <p :class="['level-item', npsUpDown, 'has-text-left']" v-html="npsPercentage"></p>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
      <!-- MORE ACTIONS -->
      <p v-if="!hasThreeOrMoreReplied" class="is-hidden-mobile mt45">&nbsp;</p>
      <p v-if="hasThreeOrMoreReplied" class="has-text-left more-actions is-hidden-mobile">More Actions</p>
      <div v-if="hasThreeOrMoreReplied" class="columns is-hidden-mobile">
        <div class="column">
          <div class="more-actions-card">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">
                  <img
                    src="/static/img/new/menu/share.png"
                    srcset="
                      /static/img/new/menu/share@2x.png 1.5x,
                      /static/img/new/menu/share@2x.png 2x,
                      /static/img/new/menu/share@3x.png 3x
                    "
                  />
                </div>
                <p class="level-item">
                  I want to&nbsp;&nbsp;<span class="bolder"
                >Share My Reviews</span
                >
                </p>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="action-title has-text-centered has-text-weight-bold">
                  Social Posts
                </p>
                <p class="action-body has-text-centered">
                  Show off your top reviews with our easy-to-use social<br/>design
                  and sharing tool, publishing posts straight to your<br/>Facebook,
                  Instagram, Twitter and LinkedIn channels.
                </p>
                <button class="home-btn has-text-centered" data-track="create a social post portal home"
                        @click="createSocialPost">
                  Create A Social Post
                </button>
                <p class="see-how-to has-text-centered has-text-weight-bold">
                  <a data-track="see how to create a social post portal home"
                     href="https://intercom.help/hellopeter/en/articles/4403194-social-ads"
                     target="_blank">See How To</a>
                </p>
              </div>
              <div class="column">
                <p class="action-title has-text-centered has-text-weight-bold">
                  Widgets
                </p>
                <p class="action-body has-text-centered">
                  Share what customers are saying by embedding review badges<br/>and
                  widgets on your website, giving them the confidence to buy<br/>from
                  you.
                </p>
                <button class="home-btn has-text-centered" data-track="add a widget portal home" @click="addWidget()">
                  Add A Widget
                </button>
                <p class="see-how-to has-text-centered has-text-weight-bold">
                  <a data-track="see how to add a widget portal home"
                     href="https://intercom.help/hellopeter/en/collections/2155411-widget-library"
                     target="_blank">See How To</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isGettingInfo" class="column is-full-height sidebar is-paddingless is-hidden-mobile">
      <the-update-alert/>
      <img v-if="showSummerCampaign" alt="summer campaign" class="summer-banner"
           src="/static/img/new/home/summer-campaign.png"
           srcset="/static/img/new/home/summer-campaign@2x.png 1.5x, /static/img/new/home/summer-campaign@2x.png 2x, /static/img/new/home/summer-campaign@3x.png 3x"/>
      <img v-if="!hasThreeOrMoreReplied || showSummerCampaign" class="shane" src="/static/img/new/home/shane.png"
           srcset="/static/img/new/home/shane@2x.png 1.5x, /static/img/new/home/shane@2x.png 2x, /static/img/new/home/shane@3x.png 3x"/>
      <p v-if="!hasThreeOrMoreReplied && !showSummerCampaign" class="has-text-centered Hello-there-Im-Shane">Hello
        there, I'm Shane</p>
      <p v-if="showSummerCampaign" class="has-text-centered Hello-there-Im-Shane">Hello, I'm Shane</p>
      <p v-if="!hasThreeOrMoreReplied && !showSummerCampaign"
         class="has-text-centered Welcome-onboard-Still-finding-your-way-around-here-Let-me-give-you-a-hand-Lets-set-up-a-quick">
        Welcome onboard! Still finding your way around here? Let me give you a hand. Let’s set up a quick demo to take
        you through all the features and come up with the best plan of action for your business. Drop your details
        below, and I’ll be in touch soon to set up a demo at a time that works for you.
      </p>
      <p v-if="showSummerCampaign"
         class="has-text-centered Welcome-onboard-Still-finding-your-way-around-here-Let-me-give-you-a-hand-Lets-set-up-a-quick lh20"
         v-html="summerCopy"></p>
      <input v-if="!hasThreeOrMoreReplied && !showSummerCampaign" v-model="shane_contact_address" autocomplete="off"
             class="sidebar-input" name="shane_contact_address" placeholder="Email address"
             type="text"/>
      <button v-if="!hasThreeOrMoreReplied && !showSummerCampaign"
              :class="['button', 'contact-btn', 'has-text-centered', { 'is-loading' : is_sending }]"
              data-track="Contact Me Portal Home" @click="contactMe">
        Contact&nbsp;Me
      </button>
      <button v-if="showSummerCampaign"
              :class="['button', 'contact-btn', 'chat-to-me', 'has-text-centered', { 'is-loading' : is_sending }]"
              data-track="Chat to me now"
              @click="chatToMe">Chat&nbsp;To&nbsp;Me&nbsp;Now
      </button>
      <img v-if="!hasThreeOrMoreReplied" class="getting-started" src="/static/img/new/home/getting-started.png"
           srcset="/static/img/new/home/getting-started@2x.png 1.5x, /static/img/new/home/getting-started@2x.png 2x, /static/img/new/home/getting-started@3x.png 3x"/>
      <img v-if="hasThreeOrMoreReplied" class="getting-started mt30" src="/static/img/new/home/no-shane.png"
           srcset="/static/img/new/home/no-shane@2x.png 1.5x, /static/img/new/home/no-shane@2x.png 2x, /static/img/new/home/no-shane@3x.png 3x"/>
      <p v-if="!hasThreeOrMoreReplied" class="Getting-Started">Getting Started</p>
      <p v-if="hasThreeOrMoreReplied" class="Getting-Started">Need Help?</p>
      <p v-if="!hasThreeOrMoreReplied"
         class="Feeling-a-bit-lost-Weve-got-your-back-Check-out-our-quick-guides-to-help-you"><a
        data-track="Feeling a bit lost portal home"
        href="https://biz.hellopeter.com/blog/q1-in-review-latest-hellopeter-updates-and-new-features" target="_blank">Feeling
        a bit lost? We’ve got your back. Check out our quick guides to help you.</a></p>
      <p v-if="hasThreeOrMoreReplied"
         class="Feeling-a-bit-lost-Weve-got-your-back-Check-out-our-quick-guides-to-help-you"><a
        data-track="Getting started portal home" href="https://intercom.help/hellopeter/en/" target="_blank">Troubleshoot
        problems or contact our support team to assist.</a></p>
      <p v-if="hasThreeOrMoreReplied" class="getting-started-link"><b>Getting Started</b><br/><a
        data-track="Getting Started portal home" href="https://intercom.help/hellopeter/en/" target="_blank">Feeling a
        bit lost? We’ve got your back. Check out our quick guides to help you.</a></p>
      <p class="getting-started-link"><b>What's New?</b><br/><a data-track="Whats new portal home"
                                                                href="https://biz.hellopeter.com/blog/tag/product-company-updates"
                                                                target="_blank">All
        the latest features and tools ready for you to explore.</a></p>
      <p class="getting-started-link"><b>How-to Guides</b><br/><a data-track="how to guide portal home"
                                                                  href="https://intercom.help/hellopeter/en/"
                                                                  target="_blank">Check out
        our handy step-by-step guides on how to use our features and to answer all your FAQs.</a></p>
      <p v-if="!hasThreeOrMoreReplied" class="getting-started-link"><b>Need Help?</b><br/><a
        data-track="Need help portal home"
        href="https://www.hellopeter.com/contact-us"
        target="_blank">Troubleshoot
        problems or contact our support team to assist.</a></p>
    </div>
    <!-- GMB Modal -->
    <GMBModal
      :show="toggleGMBModal"
      @closeModal="toggleGMBModal=false"
      @updateFinished="gmbUpdateFinished"
    ></GMBModal>
  </div>
</template>
<script>
/* eslint-disable no-undef */
import moment from 'moment'
import {DateSelectFilter, Rating, TheUpdateAlert} from '@/components'
import {gmb, misc} from '@/mixins'
import axios from 'axios'
import GMBModal from '@/components/GMBModal.vue'
import {TooltipNew} from '@/widgets'

export default {
  name: 'HomeNew',
  metaInfo: {
    title: 'Business Portal | Hellopeter - Home'
  },
  mixins: [misc, gmb],
  components: {
    DateSelectFilter,
    Rating,
    GMBModal,
    TooltipNew,
    TheUpdateAlert
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Portal-Home'
    })
    window.events.$on('show-invite-modal', () => {
      this.showInviteUserModal()
    })
    this.getBusinessInfo()
      .then(() => {
        this.filters.dateFilter.startDate = this.filters.dateFilter.reviews_start_date
        this.filters.dateFilter.endDate = moment().format('YYYY-MM-DD')
      })

    const today = moment()
    const campaignEnd = moment('2023-02-28')
    if (!today.isAfter(campaignEnd)) {
      this.getSummerCampaignCategory().then((d) => console.log('result', d))
    }
    this.checkGMBSetup()
    this.checkFacebookReviewsSetup()
  },
  created () {
    this.getReviewCountStats()
    this.getIndustryDetails()
    let dateTo = moment()
    let dateFrom = moment()
    dateTo.subtract(1, 'months').endOf('month')
    dateFrom.subtract(12, 'months').startOf('month')
    this.filters.dateFilter.lastTwelveStartDate = dateFrom.format('YYYY-MM-DD')
    this.filters.dateFilter.lastTwelveEndDate = dateTo.format('YYYY-MM-DD')
    // window.events.$on('launchCollectModal', () => {
    //   this.launchCollectModal()
    // })
    window.events.$emit('setNewBackground')
  },
  destroyed () {
    window.events.$emit('unsetNewBackground')
    window.events.$off('show-invite-modal')
    // window.events.$off('launchCollectModal')
  },
  data () {
    return {
      industryName: '',
      industrySlug: '',
      getting_info: true,
      info: {
        totalReviews: 0,
        unreadReviews: 0,
        readReviews: 0,
        unrepliedReviews: 0,
        repliedReviews: 0
      },
      shane_contact_address: '',
      is_sending: false,
      facebookReviewsLoginURL: '',
      toggleGMBModal: false,
      perf: {
        reviews: 0,
        rating: 0,
        trustIndex: 0,
        rank: 0,
        time: 0,
        nps: 0
      },
      prevPerf: {
        reviews: 0,
        rating: 0,
        trustIndex: 0,
        rank: 0,
        time: 0,
        nps: 0
      },
      fetching_performance: false,
      whatsapp_mobile: '',
      invite_name: '',
      invite_email: '',
      invite_mobile: '',
      role: 'user',
      showInviteModal: false,
      showCollectModal: false,
      isWhatsAppActive: true,
      stars: 4,
      user: {
        name: `${localStorage.getItem('first_name')} ${localStorage.getItem('last_name')}`,
        businessSlug: localStorage.getItem('org_slug'),
        facebookPageId: '',
        originalLoginUrl: '',
        pageAccessToken: '',
        isAddTabButtonVisible: true,
        gmbSetup: null
      },
      business: null,
      businessName: localStorage.getItem('org_name'),
      useColumnClass: false,
      filters: {
        dateFilter: {
          label: 'Last 12 months',
          endDate: null,
          startDate: null,
          reviews_start_date: '2015-01-01',
          lastTwelveStartDate: null,
          lastTwelveEndDate: null,
          props: [
            {
              name: 'date',
              label: 'Date',
              showApplyBtn: false,
              default: {type: 'months', value: 5, selected: 'Last 12 months'}, // moment.js placeholder in type
              disabled: [],
              elements: [
                'All time',
                'Last 7 days',
                'Previous month',
                'Last 6 months',
                'Last 12 months'
              ]
            }
          ]
        }
      },
      summerCategory: 'none',
      summerCurrent: '',
      summerPrevious: ''
    }
  },
  computed: {
    isGettingInfo () {
      return this.getting_info
    },
    showSummerCampaign () {
      if (this.summerCategory === 'none') {
        return false
      }
      const today = moment()
      const campaignEnd = moment('2023-02-28')
      if (today.isAfter(campaignEnd)) {
        return false
      }
      return true
    },
    summerCopy () {
      const name = this.businessName
      const free = `🎁Exclusive offer for you,<br/>${name}.<br/><b>Upgrade and enjoy up to 30% off<br/>selected Growth Annual Plans<br/>or up to 50% off selected Premium Plans.</b><br/>T&Cs apply.`
      const churned = `We missed you,<br/>${name}!<br/>🎁 To show you just how much, take up to <b>30% off selected Growth Annual Plans or up to 50% off selected Premium Plans<br/>if you upgrade now!</b><br/>T&Cs apply.`
      const downgraded = `${name}...<br/>We have an exclusive offer for you.<br/>🎁 <b>Upgrade now to enjoy up to<br/>30% off selected Growth Annual Plans<br/>or up to 50% off selected Premium Plans.</b><br/>T&Cs apply.`
      const expansion = `Want more for less in 2023,<br/>${name}?<br/>🎁 Stop topping up on credits and instead <b>enjoy better benefits on a new tailored discounted plan.</b><br/>T&Cs apply.`
      if (this.summerCategory === 'free') {
        return free
      }
      if (this.summerCategory === 'churned') {
        return churned
      }
      if (this.summerCategory === 'downgraded') {
        return downgraded
      }
      return expansion
    },
    isAvailableForBlackFriday () {
      const today = moment()
      const campaignEnd = moment('2022-11-30')
      if (today.isAfter(campaignEnd)) {
        return false
      }
      if (this.isFreeSubscription) {
        return true
      }
      if (this.isGrowthSubscription) {
        const allowed = ['G1 Annual', 'G2 Annual', 'G1 Monthly', 'G2 Monthly']
        return allowed.indexOf(this.userInfo.subscription.name) !== -1
      }
      return false
    },
    /**
     * Check if GMB is set or not
     * @return {void}
     */
    isGMBSettedUp () {
      if (this.gmbSetup.token === undefined) {
        return false
      }
      if (this.gmbSetup.data !== undefined && this.gmbSetup.data !== null) {
        return true
      }
      return false
    },
    whatsAppInviteURL () {
      const n = localStorage.getItem('org_name')
      return `https://wa.me/27212066516?text=${encodeURIComponent('To start writing a review about ')}${encodeURIComponent(n)}${encodeURIComponent(' PRESS SEND')}`
    },
    hasReviewsForPeriod () {
      return this.perf.reviews > 0
    },
    greeter () {
      return `${this.user.name}`
    },
    greeterMobile () {
      return `Welcome back, ${this.user.name}`
    },
    replyImage () {
      if (this.info.totalReviews === 0 || this.info.unreadReviews === 0) {
        return `/static/img/new/home/no-reviews.png`
      }
      return `/static/img/new/home/has-reviews.png`
    },
    replyImageSet () {
      if (this.info.totalReviews === 0 || this.info.unreadReviews === 0) {
        return `/static/img/new/home/no-reviews@2x.png 1.5x, /static/img/new/home/no-reviews@2x.png 2x, /static/img/new/home/no-reviews@3x.png 3x`
      }
      return `/static/img/new/home/has-reviews@2x.png 1.5x, /static/img/new/home/has-reviews@2x.png 2x, /static/img/new/home/has-reviews@3x.png 3x`
    },
    replyBold () {
      if (this.info.totalReviews === 0) {
        return 'No Reviews'
      }
      if (this.info.unreadReviews === 0) {
        return 'You\'re All Up To Date!'
      }
      return `Congratulations!`
    },
    replyText () {
      if (this.info.totalReviews === 0) {
        return 'You don\'t have any reviews'
      }
      if (this.info.unreadReviews === 0) {
        return 'You\'ve read them all'
      }
      if (this.info.unreadReviews === 1 && this.info.totalReviews === 1) {
        return 'You have your first review'
      }
      return `You have reviews waiting`
    },
    replyButtonText () {
      if (this.info.totalReviews > 0 && this.info.unreadReviews === 0) {
        return 'View My Reviews'
      }
      return 'Reply Now'
    },
    starRatingValue () {
      if (this.perf.reviews === 0) {
        return `<br/>no&nbsp;data`
      }
      if (this.perf.reviews > 99999) {
        return `<b>${this.perf.rating}&nbsp;star&nbsp;</b>rating<br/>${this.perf.reviews}&nbsp;reviews`
      }
      return `<b>${this.perf.rating}&nbsp;star&nbsp;</b>rating<br/>${this.perf.reviews}&nbsp;total&nbsp;reviews`
    },
    starRatingValueMobile () {
      if (this.perf.reviews === 0) {
        return `<br/>no&nbsp;data`
      }
      if (this.perf.reviews > 99999) {
        return `<b>${this.perf.rating}</b>&nbsp;star&nbsp;rating<br/>${this.perf.reviews}&nbsp;reviews`
      }
      return `<b>${this.perf.rating}</b>&nbsp;star&nbsp;rating<br/>${this.perf.reviews}&nbsp;total&nbsp;reviews`
    },
    starRatingFooter () {
      const prev = parseFloat(this.prevPerf.rating)
      const curr = parseFloat(this.perf.rating)
      if (prev === 0 && curr === 0 && this.perf.reviews === 0 && this.prevPerf.reviews === 0) {
        return ``
      }
      const updown = curr > prev ? 'up' : 'down'
      return `<img src="/static/img/new/home/arrow-${updown}.png" srcset="/static/img/new/home/arrow-${updown}@2x.png 1.5x, /static/img/new/home/arrow-${updown}@2x.png 2x, /static/img/new/home/arrow-${updown}@3x.png 3x" />`
    },
    starRatingUpDown () {
      const prev = parseFloat(this.prevPerf.rating)
      const curr = parseFloat(this.perf.rating)
      if (curr > prev) {
        return 'up'
      }
      return 'down'
    },
    starRatingPercentage () {
      const prev = parseFloat(this.prevPerf.rating)
      const curr = parseFloat(this.perf.rating)
      const diff = (((Math.max(prev, curr) - Math.min(prev, curr)) / prev) * 100.00).toFixed(1)
      return `${diff}%`
    },
    trustIndexValue () {
      if (this.perf.trustIndex === 0) {
        return `<br/>no&nbsp;data`
      }
      if (this.filters.dateFilter.label === 'all_time') {
        return `<b>${this.prevPerf.trustIndex.toFixed(2)}&nbsp;</b>/&nbsp;10<br /><b>trust</b>index<br />rating`
      }
      return `<b>${this.perf.trustIndex.toFixed(2)}&nbsp;</b>/&nbsp;10<br /><b>trust</b>index<br />rating`
    },
    trustIndexValueMobile () {
      if (this.perf.trustIndex === 0) {
        return `<br/>no&nbsp;data`
      }
      if (this.filters.dateFilter.label === 'all_time') {
        return `<b>${this.prevPerf.trustIndex.toFixed(2)}&nbsp;</b>/&nbsp;10<br /><b>trust</b>index&nbsp;rating`
      }
      return `<b>${this.perf.trustIndex.toFixed(2)}&nbsp;</b>/&nbsp;10<br /><b>trust</b>index&nbsp;rating`
    },
    trustIndexFooter () {
      if (this.perf.trustIndex === 0 && this.prevPerf.trustIndex === 0 && this.perf.reviews === 0 && this.prevPerf.reviews === 0) {
        return ``
      }
      const updown = this.perf.trustIndex > this.prevPerf.trustIndex ? 'up' : 'down'
      return `<img src="/static/img/new/home/arrow-${updown}.png" srcset="/static/img/new/home/arrow-${updown}@2x.png 1.5x, /static/img/new/home/arrow-${updown}@2x.png 2x, /static/img/new/home/arrow-${updown}@3x.png 3x" />`
    },
    trustIndexUpDown () {
      if (this.perf.trustIndex > this.prevPerf.trustIndex) {
        return 'up'
      }
      return 'down'
    },
    trustIndexPercentage () {
      const diff = (((Math.max(this.perf.trustIndex, this.prevPerf.trustIndex) - Math.min(this.perf.trustIndex, this.prevPerf.trustIndex)) / this.prevPerf.trustIndex) * 100.00).toFixed(1)
      return `${diff}%`
    },
    industryRankValue () {
      if (this.perf.rank === 0) {
        return `<br/>no&nbsp;data`
      }
      if (this.filters.dateFilter.label === 'all_time') {
        return `<b>#${this.prevPerf.rank}</b><br /><b>ranked</b>&nbsp;in<br /><a target="_blank" href="${this.industryUrl}">${this.industryName}</a>`
      }
      return `<b>#${this.perf.rank}</b><br /><b>ranked</b>&nbsp;in<br /><a target="_blank" href="${this.industryUrl}">${this.industryName}</a>`
    },
    industryRankValueMobile () {
      if (this.perf.rank === 0) {
        return `<br/>no&nbsp;data`
      }
      if (this.filters.dateFilter.label === 'all_time') {
        return `<b>#${this.prevPerf.rank}</b><br />in&nbsp;<a target="_blank" href="${this.industryUrl}">${this.industryName}</a>`
      }
      return `<b>#${this.perf.rank}</b><br />in&nbsp;<a target="_blank" href="${this.industryUrl}">${this.industryName}</a>`
    },
    industryUrl () {
      return `${process.env.HP_APP_URL}/industries/${this.industrySlug}`
    },
    industryFooter () {
      if (this.perf.rank === 0 && this.prevPerf.rank === 0 && this.perf.reviews === 0 && this.prevPerf.reviews === 0) {
        return ``
      }
      const updown = this.perf.rank < this.prevPerf.rank ? 'up' : 'down'
      return `<img src="/static/img/new/home/arrow-${updown}.png" srcset="/static/img/new/home/arrow-${updown}@2x.png 1.5x, /static/img/new/home/arrow-${updown}@2x.png 2x, /static/img/new/home/arrow-${updown}@3x.png 3x" />`
    },
    industryUpDown () {
      if (this.perf.rank < this.prevPerf.rank) {
        return 'up'
      }
      return 'down'
    },
    industryPercentage () {
      const diff = ((Math.min(this.perf.rank, this.prevPerf.rank) / Math.max(this.perf.rank, this.prevPerf.rank)) * 100.00).toFixed(1)
      return `${diff}%`
    },
    timeToReplyValue () {
      let t = this.perf.time
      if (t === 0) {
        return `<br/>no&nbsp;data`
      }
      return `<b>${moment.duration(Math.ceil(t), 'minutes').humanize()}</b><br /><b>average</b><br />time&nbsp;to&nbsp;reply`
    },
    timeToReplyValueMobile () {
      let t = this.perf.time
      if (t === 0) {
        return `<br/>no&nbsp;data`
      }
      return `<b>${moment.duration(Math.ceil(t), 'minutes').humanize()}</b><br /><b>avg</b>&nbsp;time&nbsp;to&nbsp;reply`
    },
    timeToReplyFooter () {
      if (this.perf.time === 0 && this.prevPerf.time === 0 && this.perf.reviews === 0 && this.prevPerf.reviews === 0) {
        return ``
      }
      const updown = this.perf.time > this.prevPerf.time ? 'up' : 'down'
      return `<img src="/static/img/new/home/arrow-${updown}.png" srcset="/static/img/new/home/arrow-${updown}@2x.png 1.5x, /static/img/new/home/arrow-${updown}@2x.png 2x, /static/img/new/home/arrow-${updown}@3x.png 3x" />`
    },
    timeToReplyUpDown () {
      if (this.perf.time > this.prevPerf.time) {
        return 'up'
      }
      return 'down'
    },
    timeToReplyPercentage () {
      const diff = (((Math.max(this.perf.time, this.prevPerf.time) - Math.min(this.perf.time, this.prevPerf.time)) / this.prevPerf.time) * 100.00).toFixed(1)
      return `${diff}%`
    },
    npsScoreValue () {
      return `${this.perf.nps}&nbsp;`
    },
    npsScoreValueMobile () {
      return `<b>${this.perf.nps}</b><br/>NET&nbsp;PROMOTOR&nbsp;SCORE`
    },
    npsImageValue () {
      let likelyness = 'likely'
      const rotateClass = this.perf.nps < 1 ? `style="transform: rotate(180deg);"` : ''
      if (this.perf.nps < 1) {
        likelyness = 'unlikely'
      }
      if (this.perf.nps > 49) {
        likelyness = 'very&nbsp;likely'
      }
      return `<b>${likelyness}&nbsp;</b><img ${rotateClass} src="/static/img/new/home/thumbs-up.png" srcset="/static/img/new/home/thumbs-up@2x.png 1.5x, /static/img/new/home/thumbs-up@2x.png 2x, /static/img/new/home/thumbs-up@3x.png 3x" />`
    },
    npsFooter () {
      if (this.perf.nps === 0 && this.prevPerf.nps === 0 && this.perf.reviews === 0 && this.prevPerf.reviews === 0) {
        return ``
      }
      const updown = this.perf.nps > this.prevPerf.nps ? 'up' : 'down'
      return `<img src="/static/img/new/home/arrow-${updown}.png" srcset="/static/img/new/home/arrow-${updown}@2x.png 1.5x, /static/img/new/home/arrow-${updown}@2x.png 2x, /static/img/new/home/arrow-${updown}@3x.png 3x" />`
    },
    npsUpDown () {
      if (this.perf.nps > this.prevPerf.nps) {
        return 'up'
      }
      return 'down'
    },
    npsPercentage () {
      const diff = (((Math.max(this.perf.nps, this.prevPerf.nps) - Math.min(this.perf.nps, this.prevPerf.nps)) / this.prevPerf.nps) * 100.00).toFixed(1)
      return `${diff}%`
    },
    /**
     * Creating a payload for HTTP request
     * @return {object}
     */
    payload () {
      return {
        endDate: this.filters.dateFilter.endDate,
        startDate: this.filters.dateFilter.startDate,
        starRating: null,
        businessSlug: this.user.businessSlug
      }
    },
    isAllTimeSelected () {
      return this.filters.dateFilter.label === 'all_time'
    },
    hasThreeOrMoreReplied () {
      return this.info.repliedReviews > 2
    }
  },
  methods: {
    /**
     * Handle Date Dropdown Filter
     * @param {object} dateFilter Date data to sort on
     * @return {void}
     */
    handleDateChange (dateFilter) {
      this.stars = 0
      Object.assign(this.filters.dateFilter, dateFilter)

      const industryId = localStorage.getItem('org_industry_id')
      const startDate = this.filters.dateFilter.startDate
      let endDate = this.filters.dateFilter.endDate
      let prevStartDate = moment()
      let prevEndDate = moment()
      switch (dateFilter.label) {
        case 'all_time':
          prevEndDate = moment()
          prevStartDate = moment()
          prevStartDate.subtract(12, 'month')
          endDate = moment().format('YYYY-MM-DD')
          break
        case 'last_7_days':
          prevEndDate = moment(startDate)
          prevStartDate = moment(startDate)
          prevEndDate.subtract(1, 'day')
          prevStartDate.subtract(7, 'day')
          break
        case 'previous_month':
          prevEndDate = moment(startDate)
          prevStartDate = moment(startDate)
          prevEndDate.subtract(1, 'month')
          prevStartDate.subtract(1, 'month')
          prevEndDate.endOf('month')
          prevStartDate.startOf('month')
          break
        case 'last_6_months':
          prevEndDate = moment(startDate)
          prevStartDate = moment(startDate)
          prevEndDate.subtract(1, 'month')
          prevStartDate.subtract(6, 'month')
          prevEndDate.endOf('month')
          prevStartDate.startOf('month')
          break
        case 'last_12_months':
          prevEndDate = moment(startDate)
          prevStartDate = moment(startDate)
          prevEndDate.subtract(1, 'month')
          prevStartDate.subtract(12, 'month')
          prevEndDate.endOf('month')
          prevStartDate.startOf('month')
          break
      }
      prevEndDate = moment(prevEndDate).format('YYYY-MM-DD')
      prevStartDate = moment(prevStartDate).format('YYYY-MM-DD')
      this.fetching_performance = true
      this.resetPerformance()

      console.log('start, prevStart, end, prevEnd', startDate, prevStartDate, endDate, prevEndDate)
      Promise.all([this.getHomePageStats(startDate, endDate, industryId), this.getHomePageStats(prevStartDate, prevEndDate, industryId)])
        .then((data) => {
          this.fetching_performance = false
          this.perf.reviews = data[0].totalReviews
          this.perf.rating = data[0].starRating.toFixed(2)
          this.perf.trustIndex = data[0].trustIndex
          this.perf.rank = data[0].industryRank
          this.perf.time = data[0].averageTimeToReply
          this.perf.nps = data[0].nps_total
          if (this.perf.reviews > 0) {
            this.stars = Math.floor(data[0].starRating)
          }
          this.prevPerf.reviews = data[1].totalReviews
          this.prevPerf.rating = data[1].starRating.toFixed(2)
          this.prevPerf.trustIndex = data[1].trustIndex
          this.prevPerf.rank = data[1].industryRank
          this.prevPerf.time = data[1].averageTimeToReply
          this.prevPerf.nps = data[1].nps_total
        })
        .catch((error) => {
          this.fetching_performance = false
          console.log('error', error)
        })
    },
    showInviteUserModal () {
      this.showInviteModal = !this.showInviteModal
    },
    launchCollectModal () {
      window.events.$emit('launchCollectModal')
    },
    resetPerformance () {
      this.perf = {
        reviews: 0,
        rating: 0,
        trustIndex: 0,
        rank: 0,
        time: 0,
        nps: 0
      }
      this.prevPerf = {
        reviews: 0,
        rating: 0,
        trustIndex: 0,
        rank: 0,
        time: 0,
        nps: 0
      }
    },
    getHomePageStats (start, end, industry) {
      return new Promise((resolve) => {
        axios.get(`${this.user.businessSlug}/homepage-stats/${start}/${end}/${industry}`)
          .then(({data}) => {
            resolve(data)
          })
          .catch((error) => {
            flash(`${error.message}`, 'is-danger')
          })
      })
    },
    getReviewCountStats () {
      this.getting_info = true
      this.info.totalReviews = 0
      this.info.unreadReviews = 0
      this.info.readReviews = 0
      this.info.unrepliedReviews = 0
      this.info.repliedReviews = 0
      axios.get(`${this.user.businessSlug}/review-count-summary`)
        .then(({data}) => {
          this.info.totalReviews = data.totalReviews
          this.info.unreadReviews = data.totalUnread
          this.info.readReviews = data.totalRead
          this.info.unrepliedReviews = data.totalUnreplied
          this.info.repliedReviews = data.totalReplied
          this.getting_info = false
        })
        .catch((err) => {
          this.getting_info = false
          console.log('error fetching review count summary data', err)
        })
    },
    getIndustryDetails () {
      const industryId = parseInt(localStorage.getItem('org_industry_id'))
      axios.get(`/search/industries`)
        .then(({data}) => {
          const found = data.find(x => x.industry_id === industryId)
          if (typeof found !== 'undefined' && typeof found.name !== 'undefined') {
            this.industryName = found.name
            this.industrySlug = found.slug
          }
        })
    },
    /**
     * Get basic information about business
     * @return {Promise}
     */
    getBusinessInfo () {
      return new Promise((resolve) => {
        axios.get(`business/${this.user.businessSlug}/info`)
          .then(({data}) => {
            this.business = data.data
            this.filters.dateFilter.reviews_start_date = data.data.review.firstReview ? moment(data.data.review.firstReview.created_at).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
            this.user.facebookPageId = data.data.business.facebook_page_id
            // this.user.pageAccessToken = data.data.business.long_lived_page_access_token
            this.user.isAddTabButtonVisible = !this.user.pageAccessToken
            resolve(data.data)
          })
          .catch((error) => {
            flash(`${error.message}`, 'is-danger')
          })
      })
    },
    getSummerCampaignCategory () {
      return new Promise((resolve) => {
        axios.get(`subscriptions/${this.user.businessSlug}/summer-campaign`)
          .then(({data}) => {
            this.summerCategory = data.category
            let prev = 'none'
            if (typeof data.prev !== 'undefined' && data.prev !== null && typeof data.prev.name !== 'undefined') {
              prev = data.prev.name
            }
            this.summerPrevious = prev
            this.summerCurrent = data.sub.name
            resolve(data.data)
          })
          .catch((error) => {
            flash(`${error.message}`, 'is-danger')
          })
      })
    },
    chatToMe () {
      this.is_sending = true
      const businessSlug = localStorage.getItem('org_slug')
      axios.post(`/subscriptions/${businessSlug}/summer-campaign/${this.summerCategory}/${this.summerPrevious}/${this.summerCurrent}`)
        .then(() => {
          this.is_sending = false
          const msg = `Successfully sent chat to me request for business ${businessSlug}`
          flash(msg)
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully sent an Chat To Me from Portal Home',
              'displayedMessage': msg
            }
          })
        })
        .catch((err) => {
          this.is_sending = false
          let msg = 'Unknown error'
          if (typeof err.response.data.errors !== 'undefined' && typeof err.response.data.errors.email !== 'undefined') {
            msg = err.response.data.errors.email[0]
          }
          this.is_sending = false
          flash(msg, 'is-danger')
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to send Chat To Me submission',
              'displayedMessage': msg
            }
          })
        })
    },
    contactMe () {
      this.is_sending = true
      const businessSlug = localStorage.getItem('org_slug')
      axios.post(`/${businessSlug}/portal-contact-me`, {
        email: this.shane_contact_address
      })
        .then(() => {
          this.is_sending = false
          const msg = `Successfully sent request to contact ${this.shane_contact_address}`
          this.shane_contact_address = ''
          flash(msg)
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully sent an Contact Me from Portal Home',
              'displayedMessage': msg
            }
          })
        })
        .catch((err) => {
          this.is_sending = false
          let msg = 'Unknown error'
          if (typeof err.response.data.errors !== 'undefined' && typeof err.response.data.errors.email !== 'undefined') {
            msg = err.response.data.errors.email[0]
          }
          this.is_sending = false
          flash(msg, 'is-danger')
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to send contact me submission',
              'displayedMessage': msg
            }
          })
        })
    },
    // copyLink  () {
    //   let url = this.whatsAppInviteURL
    //   this.$copyText(url)
    //     .then(() => {
    //       flash(`Successfully copied '${url}' to your clipboard`, 'is-success')
    //       dataLayer.push({
    //         'userMessage': {
    //           'messageType': 'success',
    //           'messageName': 'Successfully copied WhatsApp ShareLink to clipboard from home page',
    //           'displayedMessage': `Successfully copied '${this.whatsAppInviteURL}' to your clipboard`
    //         }
    //       })
    //     })
    // },
    gmbUpdateFinished () {
      this.checkGMBSetup()
      window.location.reload()
    },
    openFB () {
      const businessSlug = localStorage.getItem('org_slug')
      axios.get(`/social/fb/${businessSlug}/get-auth-url-for-reviews`)
        .then(({data}) => {
          this.facebookReviewsLoginURL = data.original_login_url
          window.location = this.facebookReviewsLoginURL
        })
        .catch((error) => {
          this.displayErrMsg(error, 'Failed loading facebook login details', 'Oops, something went wrong. Please try reloading or contact our administrator')
        })
    },
    createSocialPost () {
      this.$router.push('/ads/creator')
    },
    addWidget () {
      this.$router.push('/onsite-widgets')
    }
  }
}
</script>
<style lang="scss" scoped>
main.column.main-column {
  background-color: #f6f6f6;
}

.header--mobile {
  padding-top: 20px;
  background-color: #fff;
}

.new-home {
  max-width: 955px;
  padding-top: 20px;
  /* background-color: #f6f6f6; */

  @media screen and (max-width: 767px) {
    margin-top: -35px;
  }
}

.greeter {
  display: inline;
  width: 0 auto;
  font-family: Roboto;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  padding-left: 0.75rem;
}

.mobile-greeter {
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-top: 20px;
  color: #58595b;
}

.mobile-greeter-experience {
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #58595b;
}

.name-only {
  display: inline;
  width: 0 auto;
  font-family: Roboto;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  font-weight: 400;
}

.fixed-card {
  // width: 280px;
  width: 100%;
  // max-width: 280px;
  height: 280px;
  // margin: 10px 31px 0 0;
  margin-top: 10px;
  padding: 28px 29px 38px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
}

.fixed-card.sync {
  padding: 28px 14px 38px;
}

.fixed-card > h4 {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  // font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: #29357f;
}

.fixed-card > h3 {
  font-size: 18px;
  font-family: Roboto;
  font-weight: 600;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: #29357f;
}

.fixed-card > h5 {
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: #58595b;
}

.fixed-card > h6 {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #58595b;
  margin-top: 5px;
}

// .columns>.column:first-child {
//   padding-left: 0;
// }

.single {
  width: 35px;
  height: 41px;
  margin: 12px auto 15px auto;
  display: block;
}

.home-btn {
  background-color: #397ef5;
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  width: 180px;
  height: 35px;
  border: none;
  border-radius: 20px;
  margin: 16px auto 0 auto;
  display: block;
  cursor: pointer;
}

.columns > .column:first-child > .fixed-card > .home-btn {
  margin-top: 26px;
}

.collect-reviews {
  margin-top: 20px;
}

.collect-reviews > .column {
  padding-left: 0;
  padding-right: 0;
}

.collect-reviews > .column > img.collect-img {
  width: 53px !important;
  height: 38px !important;
}

.collect-reviews > .column:first-child > img {
  width: 60px;
  height: 45px;
  margin-top: -7px;
  min-width: 60px;
}

.collect-reviews > .column > img {
  margin-bottom: 7px;
}

.collect-reviews > .column > h2 {
  font-family: "Open Sans";
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #58595b;
}

.sync > .level {
  margin-left: 0.4rem;
}

.sync-text {
  margin: 12px 0 22px;
  font-family: "Open Sans";
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.55;
  letter-spacing: normal;
  text-align: center;
  color: #8e8e8e;
}

.sync-label,
.sync-connected {
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
}

.sync-label {
  color: #58595b;
}

.sync-connected {
  color: rgba(88, 89, 91, 0.4);
  padding-right: 3.5rem;
}

.sync-locked > a, .sync-locked > a:hover, .sync-locked > a:visited {
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  text-decoration: underline;
  color: #397ef5;
  margin-left: 0.6rem;
}

.sync-locked > img {
  width: 14px;
  height: 18px;
}

.sync-locked {
  padding-right: 2.9rem;
}

.sync-hp {
  width: 20px;
  height: 20px;
}

.sync-google {
  width: 22px;
  height: 22px;
}

.sync-fb {
  width: 26px;
  height: 26px;
}

.sync > .level.is-mobile > .level-left > .level-item:first-child {
  width: 30px;
  margin-right: 0.25rem;
}

.level:not(:last-child) {
  margin-bottom: 1.2rem;
}

.sync-connect-btn {
  background-color: #397ef5;
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 11px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  width: 130px;
  height: 25px;
  border: none;
  border-radius: 20px;
  margin-right: 0.5rem;
  display: block;
  cursor: pointer;
}

.performance {
  margin-top: 30px;
  margin-bottom: 10px;
  padding-right: 12px;
  padding-left: 0.75rem;
}

.performance.level > .level-left > p.level-item {
  font-family: "Open Sans";
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.performance.level > .level-right > p.level-item {
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
}

.performance-card {
  max-width: 170px;
  height: 130px;
  padding: 19px 0 0;
  border-radius: 5px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.performance-card > .performance-body > p {
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #707070;
}

.performance-card > footer {
  background-color: #f6f6f6;
  height: 37px;
  min-width: 100%;
  /* push footer to bottom */
  margin-top: auto;
  /* ensure width includes padding */
  box-sizing: border-box;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.performance-card > footer > .level > .level-left {
  margin: 10px auto;
}

.performance-card > footer > .level > .level-left > .level-item > img {
  width: 8px;
  height: 10px;
}

.performance-card > footer > .level > .level-left > p.level-item:first-child {
  margin-right: 4px;
}

.performance-card > footer > .level > .level-left > p.level-item {
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #00bf87;
}

.performance-card > footer > .level > .level-left > p.level-item.down {
  color: #ea3939;
}

.performance-card > footer > .level > .level-left > p.level-item.up {
  color: #00bf87;
}

.performance-card > footer > .level > .level-left > p.level-item > a,
.performance-card > footer > .level > .level-left > p.level-item > a:visited,
.performance-card > footer > .level > .level-left > p.level-item > a:hover {
  text-decoration: underline;
  color: #397ef5;
}

.performance-card > .performance-body > p > img {
  width: 15px;
  height: 16px;
}

.performance-card > .performance-body > p.blue-nps {
  color: #397ef5;
  line-height: 16px;
}

p.more-actions {
  margin-top: 20px;
  font-family: "Open Sans";
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
  padding-left: 0.75rem;
}

.more-actions-card {
  margin: 10px 0 0;
  padding: 17.4px 16.5px 31px 17.5px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
}

.more-actions-card > .level {
  margin-bottom: 12px;
}

.more-actions-card > .level > .level-left > .level-item > img {
  width: 18px;
  height: 18px;
}

.more-actions-card > .level > .level-left > p.level-item {
  font-family: "Roboto";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #29357f;
}

.more-actions-card .bolder {
  font-size: 14px;
  font-weight: bold;
}

.more-actions-card > .columns {
  border-top: 1px solid #eaeaea;
}

.action-title {
  font-family: "Open Sans";
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #58595b;
  margin-top: 20px;
  margin-bottom: 10px;
}

.action-body {
  font-family: "Open Sans";
  font-size: 11px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #58595b;
}

.see-how-to {
  margin-top: 20px;
  font-family: "Roboto";
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}

.see-how-to > a,
.see-how-to > a:visited,
.see-how-to > a:hover {
  text-decoration: underline;
  color: #397ef5;
}

.more-actions + .columns {
  margin-bottom: 30px;
}

/*
 * Side bar
 */

.sidebar {
  background-color: #fff;
  max-width: 340px;
  min-width: 200px;
  margin-right: 0;
  margin-left: auto;
  border-left: 1px solid #eaeaea;
  /* padding-left: 25px!important; */
  /* padding-right: 25px!important; */
}

.sidebar > p {
  margin-left: 25px;
  margin-right: 25px;
}

.shane {
  width: 60px;
  height: 60px;
  display: block;
  margin: 26px auto 0 auto;
}

.Hello-there-Im-Shane {
  max-width: 266px;
  height: 16px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
  margin-top: 20px;
}

.Welcome-onboard-Still-finding-your-way-around-here-Let-me-give-you-a-hand-Lets-set-up-a-quick {
  max-width: 280px;
  /* height: 136px; */
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
  margin-top: 20px;
}

.contact-btn {
  background-color: #397ef5;
  color: #fff;
  text-align: center;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  width: 100%;
  max-width: 130px;
  height: 35px;
  border: none;
  border-radius: 20px;
  margin: 16px auto 0 auto;
  display: block;
  cursor: pointer;
}

.sidebar-input {
  width: 100%;
  max-width: 250px;
  height: 35px;
  display: block;
  border: 1px solid #d0d0d1;
  border-radius: 20px;
  margin: 40px auto 0 auto;
  color: #656769;
  text-align: center;
  background-color: #fff;
}

/* .sidebar-input::-webkit-input-placeholder {  color: #656769;   } */
/* .sidebar-input::-moz-placeholder { color: #656769; } */
/* .sidebar-input::-moz-placeholder { color: #656769; } */
/* .sidebar-input::-ms-input-placeholder { color: #656769; } */

.sidebar-input::-webkit-input-placeholder {
  color: #d0d0d0;
}

.sidebar-input::-moz-placeholder {
  color: #d0d0d0;
}

.sidebar-input::-moz-placeholder {
  color: #d0d0d0;
}

.sidebar-input::-ms-input-placeholder {
  color: #d0d0d0;
}

.getting-started {
  width: 62px;
  height: 60px;
  display: block;
  margin: 70px auto 0 auto;
}

.Getting-Started {
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
  margin-top: 20px;
}

.Feeling-a-bit-lost-Weve-got-your-back-Check-out-our-quick-guides-to-help-you {
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #58595b;
  margin-top: 10px;
  margin-bottom: 20px;
}

.getting-started-link {
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
  border-top: 1px solid #eaeaea;
  padding-top: 15px;
  padding-bottom: 15px;
}

.Feeling-a-bit-lost-Weve-got-your-back-Check-out-our-quick-guides-to-help-you a, .Feeling-a-bit-lost-Weve-got-your-back-Check-out-our-quick-guides-to-help-you a:hover, .Feeling-a-bit-lost-Weve-got-your-back-Check-out-our-quick-guides-to-help-you a:visited,
.getting-started-link a, .getting-started-link a:visited, .getting-started-link a:hover {
  text-decoration: none;
  color: #58595b;
}

.modal-card {
  width: 400px;
}

.modal-background {
  background-color: rgba(10, 10, 10, 0.36);
}

.modal-card-head {
  border-bottom: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.modal-card-foot {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top: none;
}

.modal-card-title {
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #29357f;
}

.modal-card-head, .modal-card-foot {
  padding: 28px 25px;
  background-color: #ffffff;
}

.modal-card-body {
  padding: 10px 10px 10px 25px;
}

.modal-card-body > p {
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #58595b;
}

.modal-card-body > input {
  width: 354px;
  height: 35px;
  margin: 15px 2px 20px;
  border-radius: 17.5px;
  border: solid 1px #d0d0d0;
  background-color: #fff;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding-left: 12px;
  color: #656769;
}


.modal-card-body > input::-webkit-input-placeholder {
  color: #666666;
}

.modal-card-body > input::-moz-placeholder {
  color: #666666;
}

.modal-card-body > input::-moz-placeholder {
  color: #666666;
}

.modal-card-body > input::-ms-input-placeholder {
  color: #666666;
}

.modal-card-body > p.form-label {
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #58595b;
}

input[type="radio"]:checked {
  background-color: #29357f;
  border: 1px solid #29357f;
}

input[type="radio"] {
  width: 17px;
  height: 17px;
  padding: 3.5px;
}

.description, .radio-label {
  font-family: "Open Sans";
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.description {
  font-weight: normal;
  font-size: 12px;
}

.radio-label {
  font-weight: bold;
  font-size: 14px;
  padding-left: 16px;
}

.form-label + .control {
  margin-top: 10px;
}

.form-label + .control + .control {
  margin-top: 12px;
}

.invite-btn {
  width: 196px;
  height: 41px;
  margin: 0 auto;
  cursor: pointer;
  border: none;
  margin-bottom: 20px;
  border-radius: 20.5px;
  background-color: #397ef5;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

button.delete {
  background-color: #29357f;
}

.modal-card {
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.21);
}

.smaller > .modal-card-head {
  padding: 15px 20px 11px 20px;
}

.smaller > .modal-card-head > .modal-card-title {
  font-size: 13px;
}

.smaller > .modal-card-body {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0;
}

.smaller > .modal-card-body > .tabs {
  border: solid 1px #ececec;
  background-color: #f7f7f7;
}

.smaller > .modal-card-body > .tabs > ul > li > a {
  color: #29357f;
  font-family: Roboto;
  font-size: 11px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}

.tabs ul {
  border-bottom: none;
}

.tabs a {
  border: none;
  padding: 1.5em;
}

.smaller > .modal-card-body > .tabs > ul > li {
  border-bottom: 3px solid #f7f7f7;
}

.smaller > .modal-card-body > .tabs > ul > li.is-active {
  border-bottom: 3px solid #29357f;
}

.section-header {
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #29357f;
}

.sub-section {
  font-size: 10px;
  font-weight: normal;
  color: #58595b;
}

.ask-for-reviews {
  width: 200px;
  height: 35px;
  display: block;
  font-size: 11px;
  font-weight: 600;
  margin-left: auto;
  margin-right: auto;
}

.input-ask-for-reviews {
  width: 200px;
  height: 35px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 50px 10px 51px;
  border-radius: 17.5px;
  font-size: 11px;
  font-weight: 300;
}

.mt45 {
  margin-top: 45px;
}

.mb15 {
  margin-bottom: 15px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb10 {
  margin-bottom: 10px;
}

.tab-body {
  width: 100%;
}

.performance-card .level.is-mobile .level-item {
  margin-right: 0;
}

.mt30 {
  margin-top: 35px;
}

.mt10 {
  margin-top: 10px;
}

.mt15 {
  margin-top: 15px;
}

.mt25 {
  margin-top: 25px;
}

.level.is-mobile.mt30 .level-item {
  margin-right: 0;
}

.hr-line {
  width: 136px;
  height: 1px;
  background-color: #d0d0d0;
}

.hr-text > p {
  width: 15px;
  height: 15px;
  font-family: "Open Sans";
  font-size: 11px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666666;
}

.copy-img {
  display: block;
  width: 26px;
  height: 28px;
  margin: 40px auto 20px auto;
}

.copy-btn {
  width: 200px;
  height: 35px;
  display: block;
  margin: 0 auto 60px auto;
  border-radius: 17.5px;
  color: #397ef5;
  border: 1px solid #397ef5;
  background-color: #fff;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  cursor: pointer;
}

.send-multiple-invites, .send-multiple-invites:visited, .send-multiple-invites:hover {
  text-decoration: underline;
  font-family: "Open Sans";
  font-size: 11px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #397ef5;
}

.hr-line-full {
  width: 308px;
  height: 1px;
  margin: 18px auto 15px auto;
  background-color: #d0d0d0;
}

.footer-copy {
  width: 329px;
  height: auto;
  margin: 0 auto 10px auto;
  font-family: "Open Sans";
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666666;
}

.width236-center {
  display: block;
  width: 236px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}

.width187-center {
  display: block;
  width: 187px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}

.black-friday-banner-img {
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
}

.summer-banner {
  margin-bottom: -20px;
  /* margin-left: -25px; */
  /* margin-right: -25px; */
}

.lh20 {
  line-height: 20px;
}

.chat-to-me {
  background-color: #b0141b !important;
  font-weight: 600;
  margin-top: 25px;
}

@media screen and (max-width: 767px) {
  .performance-card {
    max-width: 100%;
    width: 100%;
    height: 55px;
    padding-top: 0px;
  }

  .performance-body {
    padding-top: 7px;
  }

  .column.is-one-fifth {
    padding: 0.25rem 0.75rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/home/HomeNew.vue